import React, {useEffect, useState} from 'react';
import Plane from './Plane/Plane';
import Stars from './Stars/Stars';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import {styled} from '@mui/material';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import Fade from '@mui/material/Fade';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {Link} from 'react-router-dom';
import {getTime} from '../../requests/timer';
import Timer from './Timer/Timer';
import { debounce } from 'lodash';

function ScrollTop(props) {
	const {children, window} = props;
	// Note that you normally won't need to set the window ref as useScrollTrigger
	// will default to window.
	// This is only being set here because the demo is in an iframe.
	const trigger = useScrollTrigger({
		target: window ? window() : undefined,
		disableHysteresis: true,
		threshold: 100,
	});

	const handleClick = (event) => {
		const anchor = (event.target.ownerDocument || document).querySelector(
			'#back-to-top-anchor'
		);

		if (anchor) {
			anchor.scrollIntoView({
				block: 'center',
			});
		}
	};

	return (
		<Fade in={trigger}>
			<Box
				onClick={handleClick}
				role='presentation'
				sx={{position: 'fixed', bottom: 16, right: 16}}
			>
				{children}
			</Box>
		</Fade>
	);
}
const isInView = (id) => {
	const el = document.getElementsByClassName(id)[0];
	const box = el && el.getBoundingClientRect();
	return box && box.top < window.innerHeight && box.bottom >= 0;
}

const MainMenu =(props)=> {
	const [scrollPosition, setScrollPosition] = useState(0);
	const [shouldBeFixed, setShouldBeFixed] = useState(false);

	const handleScroll = () => {
		const currentPosition = window.pageYOffset;
		if (currentPosition > scrollPosition && !isInView('MuiPaper-root')) {
			setShouldBeFixed(true);
		} else if (currentPosition < scrollPosition && isInView('bg-gradient-to-t from-[#e2ce9d] to-[#16e4d1]')) {
			setShouldBeFixed(false);
		}
		setScrollPosition(currentPosition);
	}

	const debouncedScroll = debounce(() => {
		handleScroll()
	}, 5);

	useEffect(() => {
		window.addEventListener('scroll', debouncedScroll);

		return () => {

			window.removeEventListener('scroll', debouncedScroll);
		};
	}, [scrollPosition])
	// useEffect(() => {
	// 	const handleScroll = () => {
	// 		const currentPosition = window.pageYOffset;
	// 		if (currentPosition > scrollPosition && !isInView('MuiPaper-root')) {
	// 			setShouldBeFixed(true);
	// 		} else if (currentPosition < scrollPosition && isInView('bg-gradient-to-t from-[#e2ce9d] to-[#16e4d1]')) {
	// 			setShouldBeFixed(false);
	// 		}
	// 		setScrollPosition(currentPosition);
	// 	}

	// 	const debouncedScroll = debounce(() => {
	// 		handleScroll()
	// 	}, 5);


	// 	window.addEventListener('scroll', debouncedScroll);

	// 	return () => {

	// 		window.removeEventListener('scroll', debouncedScroll);
	// 	};
	// }, [scrollPosition]);
	return (
		<React.Fragment>
			<AppBar
				sx={{
					position: shouldBeFixed ? 'fixed' : 'relative',
					backgroundColor: '#503854',
					overflowX: 'hidden',
					width: '100%',
				}}
			>
				<NavTabs />
			</AppBar>
			<Toolbar
				sx={{position: 'absolute', top: '0'}}
				id='back-to-top-anchor'
			/>
			<ScrollTop {...props}>
				<Fab
					sx={{fontSize: '40px', zIndex: 10}}
					size='medium'
					aria-label='scroll back to top'
				>
					&#8613;
				</Fab>
			</ScrollTop>
		</React.Fragment>
	);
}

const StyledFab = styled((props) => (<Fab {...props} />)({
	'&. MuiBox-root': {
		zIndex: 10,
		fontSize: '40px',
	}
}))

const StyledTabs = styled((props) => (
	<Tabs
		{...props}
		TabIndicatorProps={{
			children: <span className='MuiTabs-indicatorSpan' />,
		}}
	/>
))({
	'& .MuiTabs-indicator': {
		display: 'flex',
		justifyContent: 'center',
		height: '10%',
		backgroundColor: 'transparent',
	},
	'& .MuiTabs-indicatorSpan': {
		width: '100%',
		backgroundColor: '#e2ce9d',
	},

	'& .MuiTabs-flexContainer': {
		justifyContent: window.innerWidth > 900 && 'center',
	},

});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
	({theme}) => ({
		textTransform: 'none',
		fontWeight: theme.typography.fontWeightRegular,
		fontSize: theme.typography.pxToRem(15),
		marginRight: theme.spacing(1),
		fontFamily: 'Bold',
		color: 'rgba(255, 255, 255, 0.7)',
		'&.Mui-selected': {
			color: '#e2ce9d',
		},
		'&.Mui-focusVisible': {
			backgroundColor: 'rgba(100, 95, 228, 0.32)',
		},
		'&.Mui-disabled': {
			color: 'grey',
			textDecoration: 'line-through'
		}
	})
);

function NavTab({to, disabled, ...rest}) {
	const CustomLink = React.useMemo(
		() =>
			React.forwardRef(() => {
				if(disabled) {
					return <StyledTab {...rest} disabled={disabled} />
				} else {
				return (
					<Link className=' self-center' to={to}>
						<StyledTab {...rest} />
					</Link>
				);
			}}),
		[to, rest]
	);

	return (
		<StyledTab
			component={CustomLink}
			onClick={(event) => {
				event.preventDefault();
			}}
			{...rest}
		/>
	);
}

function NavTabs() {
	const [value, setValue] = React.useState('');

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	useEffect(() => {
		const arrayFromPath = window.location.pathname.split('/');
		if (arrayFromPath.length > 1) {
			setValue(window.location.pathname.split('/')[1]);
		} else {
			setValue('');
		}
	}, []);

	return (
		<Box>
			<StyledTabs
				variant='scrollable'
				allowScrollButtonsMobile
				value={value}
				onChange={handleChange}
				aria-label='nav tabs example'
			>
				<NavTab value='' label='CO TO PODSUMOWANIE?' to='/' />
				<NavTab
					value='propozycje'
					label='ZGŁASZANIE PROPOZYCJI'
					to='/propozycje'
					disabled
				/>
				<NavTab
					value='glosowanie'
					label='GŁOSOWANIE'
					to='/glosowanie'
					disabled
				/>
				<NavTab value='wyniki' label='WYNIKI' to='/wyniki' />
				<NavTab value='nagrody' label='NAGRODY' to='/nagrody' />
				<NavTab value='sponsorzy' label='SPONSORZY' to='/sponsorzy' />
			</StyledTabs>
		</Box>
	);
}

const Header = () => {
	return (
		<>
			<div className='bg-gradient-to-t from-[#e2ce9d] to-[#16e4d1]'>
				<Stars />
				<img
					className='mx-auto w-28 py-4'
					src={`${process.env.REACT_APP_API_DOMAIN}/images/poznanskirap-logo.png`}
				/>
				<Timer />
				<img
					className='mx-auto w-24'
					src={`${process.env.REACT_APP_API_DOMAIN}/images/powered-by-wujo.png`}
				/>
				<Plane />
				<img
					className='mx-auto'
					src={`${process.env.REACT_APP_API_DOMAIN}/images/header_city_panorama.png`}
					alt='poznan-panorma'
				/>
				<MainMenu />
			</div>
		</>
	);
};

export default Header;
